const darkLightProxy = (dark, light) => {
    return new Proxy({
        dark: dark, // Dark mode fill color for spray
        default: light, // Default fill color for spray
    }, {
        get(target, prop) {
            if (prop === 'dark') {
                return target.dark;
            }
            return target.default;
        }
    })
}

export default {
    point: {
        spray: {
            // Punt spuiten selected fill dark:         #FFFF73
            // Punt spuiten selected fill normaal:      #00008C
            // Punt spuiten selected stroke dark:       #0099FF
            // Punt spuiten selected stroke normaal:    #0099FF
            selected: {
                fill: darkLightProxy("#FFFF73", "#00008C"), //[255,255,73]
                stroke: darkLightProxy("#0099FF", "#0099FF")
            },
            // Punt spuiten fill dark:                  #FFFF73
            // Punt spuiten fill normaal:               #00008C
            // Punt spuiten stroke dark:                #FFFFFF
            // Punt spuiten stroke normaal:             #000000
            fill: darkLightProxy("#FFFF73", "#00008C"),
            stroke: darkLightProxy("#FFFFFF", "#000000")
        },
        drill: {
            // Punt boren selected fill dark:           #FFA500
            // Punt boren selected fill normaal:        #FF8C00
            // Punt boren selected stroke dark:         #0099FF
            // Punt boren selected stroke normaal:      #0099FF
            selected: {
                fill: darkLightProxy("#FFA500", "#FF8C00"),
                stroke: darkLightProxy("#0099FF", "#0099FF")
            },
            // Punt boren fill dark:                    #FFA500
            // Punt boren fill normaal:                 #FF8C00
            // Punt boren stroke dark:                  #4A4A4A
            // Punt boren stroke normaal:               #8B4513
            fill: darkLightProxy("#FFA500", "#FF8C00"),
            stroke: darkLightProxy("#4A4A4A", "#8B4513")
        },
        stop: {
            selected: {
                // Punt stoppen selected fill dark:         #DC143C
                // Punt stoppen selected fill normaal:      #B22222
                // Punt stoppen selected stroke dark:       #0099FF
                // Punt stoppen selected stroke normaal:    #0099FF
                fill: darkLightProxy("#DC143C", "#B22222"),
                stroke: darkLightProxy("#0099FF", "#0099FF")
            },
            // Punt stoppen fill dark:                  #DC143C
            // Punt stoppen fill normaal:               #B22222
            // Punt stoppen stroke dark:                #4A4A4A
            // Punt stoppen stroke normaal:             #000000
            fill: darkLightProxy("#DC143C", "#B22222"),
            stroke: darkLightProxy("#4A4A4A", "#000000")
        },
        drive: {
            selected: {
                // Punt rijden selected fill dark:          #666666
                // Punt rijden selected fill normaal:       #969696
                // Punt rijden selected stroke dark:        #0099FF
                // Punt rijden selected stroke normaal:     #0099FF
                fill: darkLightProxy("#666666", "#969696"),
                stroke: darkLightProxy("#0099FF", "#0099FF")
            },
            // Punt rijden fill dark:                   #666666
            // Punt rijden fill normaal:                #969696
            // Punt rijden stroke dark:                 #666666
            // Punt rijden stroke normaal:              #969696
            fill: darkLightProxy("#666666", "#969696"),
            stroke: darkLightProxy("#666666", "#969696")
        },
    },
    line: {
        spray: {
            selected: {
                dark: "#0099FF",
                default: "#0099FF"
            },
            dark: "#FFFFFF",
            default: "#000000"
        },
        drive: {
            selected: {
                dark: "#0099FF",
                default: "#0099FF"
            },
            dark: "#666666",
            default: "#969696"
        }
    }
}
// Lijn selected:                           [#FFFFFF, #0099FF]
// Rijlijn normaal:                         #969696
// Rijlijn dark:                            #666666
// Spuitlijn normaal:                       #000000
// Spuitlijn dark:                          #FFFFFF



